











































































































import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: "QrHeader"
})
export default class QrHeader extends Vue {

}
